import { JJUpdatesHeader } from '../JJUpdatesHeader'
import { JJResourcesList } from './JJResourcesList'

export const JJResourcesPage = () => {
  return (
    <JJUpdatesHeader currentTab={'/JJUpdates/Resources'}>
      <JJResourcesList />
    </JJUpdatesHeader>
  )
}
